import { DataTableCustomized } from '@/components/ui/data-table-customized'
import Paper from '@/components/Paper'
import { useCreditTransactions } from './use-credit-transactions'
import { useModal } from '@/contexts/modal'
import { useParams } from 'react-router-dom'
import { Button } from 'vnetwork-ui'
import AddIcons from '@/icons/AddIcons'

const List = () => {
    const { id } = useParams()
    const { setModal } = useModal()
    const {
        transactions,
        pagination,
        stateComponent,
        isFetching,
        params,
        columns,
        searchInputProps,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useCreditTransactions()

    return (
        <Paper data-tour="credit-transactions">
            {stateComponent || (
                <DataTableCustomized
                    columns={columns}
                    rows={transactions}
                    rowKey={(row) => String(row?.credit_transaction_id)}
                    size="small"
                    resizable
                    loading={!transactions.length && !pagination}
                    isFetching={isFetching}
                    emptyMessage={t('no_credit_transactions', {
                        defaultValue: 'Không có giao dịch credit nào',
                    })}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                    pagination={
                        pagination
                            ? {
                                  page: params.page || 1,
                                  pageSize: params.page_size || 10,
                                  total: pagination.total || 0,
                                  onPageChange: handlePageChange,
                                  onPageSizeChange: handlePageSizeChange,
                                  pageSizeOptions: [10, 20, 50, 100],
                              }
                            : undefined
                    }
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('search-credit-transactions', {
                                defaultValue: 'Tìm kiếm giao dịch...',
                            }),
                        },
                        slotComponents: [
                            <Button
                                key="create-credit"
                                size="small"
                                variant="contained"
                                startIcon={<AddIcons />}
                                onClick={() =>
                                    setModal(
                                        'CreditModals/CreateCreditModal/index',
                                        {
                                            customerID: Number(id),
                                            creditID: 0,
                                        }
                                    )
                                }
                            >
                                {t('customers.credits.create', {
                                    defaultValue: 'Tạo ký quỹ',
                                })}
                            </Button>,
                        ],
                        settings: {
                            show: true,
                            storageKey: 'customer-credit-transactions',
                        },
                    }}
                />
            )}
        </Paper>
    )
}

export default List
